<template>
  <div id="intro_member_outer">
    <div id="intro_member_menu" v-show="userId == null">
      <a v-for="(item, index) in menuList"
         :key="'intro_menu_index_' + index"
         :class="[subIndex == index ? 'active' : '']"
         :href="currentPath + '/' + menuId + '/' + (index + 1)"
      >{{item}}</a>
    </div>
    <div id="intro_member_content" v-if="userId == null">
      <member-rules v-if="subIndex == 0" />
      <member-list v-if="subIndex == 1" />
    </div>

<!--    详情页-->
    <div id="intro_member_detail" v-else>
      <member-detail />
    </div>
  </div>
</template>

<script>
import GlobalInstance from '../../js/shba'
import MemberRules from "./MemberRules";
import MemberList from "./MemberList";
import MemberDetail from "./MemberDetail";
export default {
  name: "Member",
  components: {MemberList, MemberRules, MemberDetail},
  data() {
    return {
      title: '协会成员',
      menuList: ['会员介绍', '会员列表'],
    }
  },
  computed: {
    subIndex() {
      let index = this.$route.params.index;
      return index != undefined ? (index - 1) : 0;
    },
    menuId() {
      let id = GlobalInstance.methods.currentSubTabId(this.$route);
      return id;
    },

    currentPath() {
      let item = GlobalInstance.methods.currentMenuItem(this.$route);
      return item.src;
    },

    userId() {
      let userId = this.$route.params.userId;
      if (userId == undefined) {
        return null;
      }
      return userId;
    }
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style scoped>
  #intro_member_outer {
    width: 100%;
    padding: 0 ;
  }

  @media screen and (min-width: 768px) {
    #intro_member_outer {
      width: 100%;
    }
  }

  #intro_member_menu {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  #intro_member_menu > a {
    color: #333;
    font-size: 1.5rem;
    font-weight: bold;
    /*width: 100px;*/
    text-decoration: none;
    padding: 4px 0px;
  }

  #intro_member_menu > a:last-child {
    margin-left: 30px;
  }

  #intro_member_menu > a.active, #intro_member_menu > a:hover {
    color: #fc1a34;
  }

  #intro_member_menu > a.active {
    pointer-events: none;
    border-bottom: solid 3px #fc1a34;
  }

  #intro_member_content, #intro_member_detail {
    margin-top: 30px;
    padding-bottom: 30px;
  }

  #intro_member_detail {
    width: 100%;
   }

</style>



// WEBPACK FOOTER //
// src/components/introduce/Member.vue